import * as React from "react";
import { connect } from "react-redux";
import { Button, Card } from "antd";
import { FormattedMessage } from "react-intl";

import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Alias } from "@models/alias";
import { deleteRequest, fetchRequest } from "@actions/alias";
import AliasesTable from "@components/aliases/Table";
import TableRenderer from "@hocs/TableRenderer";
import { NavLink } from "react-router-dom";
import { getAliasesList } from "@reducers/alias";
import SearchAliasesComponent from "@components/aliases/Search";

interface PropsFromState {
  loading: boolean;
  data: Alias[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class AliasesIndexPage extends React.Component<AllProps> {
  deleteAlias = (item: Alias): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const { loading, data, search, currentPage } = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/aliases/create`}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.create_new_alias"
                defaultMessage={`Create Alias`}
              />
            </Button>
          </NavLink>
        </div>
        <div className={"page-table-wrapper"}>
          <Card bordered={false} className={`page-table-header search-part`}>
            <SearchAliasesComponent search={search} />
          </Card>

          <AliasesTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteAlias}
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ aliases }: ApplicationState) => ({
  loading: aliases.loading,
  errors: aliases.errors,
  data: getAliasesList(aliases),
  count: aliases.count
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(AliasesIndexPage));
